import { useEffect, useState } from 'react'
import { useForm, UseFormProps } from 'react-hook-form'

interface useFormReinitializeProps extends UseFormProps {
  canReinitialize?: boolean
}

export const useFormReinitialize = ({
  canReinitialize,
  ...formProps
}: useFormReinitializeProps) => {
  const [isReinitialized, setIsReinitialized] = useState(false)
  const { defaultValues } = formProps
  const form = useForm({ ...formProps })

  useEffect(() => {
    if (!isReinitialized && canReinitialize) {
      form.reset(defaultValues)
      setIsReinitialized(true)
    }
  }, [canReinitialize])

  return { ...form }
}
